import wildcard from 'wildcard';
import moment from 'moment-timezone';
import { transparentize } from 'polished';
import { cloneDeep } from 'lodash-es';

export const checkPerm = (permission, permissions) => {
  let p = permission;
  if (typeof p === 'string') {
    p = [permission];
  }
  return permissions.some((perm) => wildcard(perm, permission).length > 0);
};

export const getPerm = (permission, permissions) => {
  let p = permission;
  if (typeof p === 'string') {
    p = [permission];
  }
  return permissions.reduce((acc, cur) => [...acc, ...wildcard(cur, p)], []);
};

export function commaize(num) {
  return (num ? num : 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); // eslint-disable-line
}

export function getDateString(date, type = 'all') {
  if (!date) return '---';
  const momentParsed = moment(date);
  const dateFormat = 'DD-MMM-YYYY';
  const timeFormat = 'HH:mm';
  if (type === 'all') return momentParsed.format(`${dateFormat} ${timeFormat}`);
  else if (type === 'date') return momentParsed.format(dateFormat);
  return momentParsed.format(timeFormat);
}

export function capitalize(str = '') {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
}

export function lightenColor(date, color) {
  const dateDiff = Math.abs(moment(date).startOf('day').diff(moment().startOf('day'), 'day'));
  const maxRatio = 60;
  const ratio = Math.abs(1 - (((maxRatio + 10) - (dateDiff > maxRatio ? maxRatio : dateDiff)) / maxRatio));
  return transparentize(ratio, color);
}

export function tripDateDiffString(date) {
  if (!date) return '';
  const dateDiff = moment(date).startOf('day').diff(moment().startOf('day'), 'day');
  if (dateDiff === 0) {
    return 'Today';
  } else if (dateDiff > 0) {
    return `In ${dateDiff} days`;
  }
  return 'Trip has passed';
}

export function checkIdCardNumber(id) {
  if (id.length !== 13) return false;
  let sum = 0;
  for (let i = 0; i < 12; i += 1) {
    sum += parseFloat(id.charAt(i)) * (13 - i);
  }
  if ((11 - (sum % 11)) % 10 !== parseFloat(id.charAt(12))) return false;
  return true;
}

export function removeArrayItem(arr, index) {
  const cloneArr = cloneDeep(arr);
  return [
    ...cloneArr.slice(0, index),
    ...cloneArr.slice(index + 1)
  ];
}

export function insertArrayItem(arr, item, where, index) {
  const cloneArr = cloneDeep(arr);
  if (where === 'top') {
    return [
      ...cloneArr.slice(0, index),
      item,
      ...cloneArr.slice(index)
    ];
  } else if (where === 'bottom') {
    return [
      ...cloneArr.slice(0, index + 1),
      item,
      ...cloneArr.slice(index + 1)
    ];
  }
  return cloneArr;
}

export function randomUniqueString() {
  const randNum = Math.random().toString(36).substr(2);
  return randNum;
}

export function getDefaultNearestEffDate(asString = true) {
  const startOfDay = moment().startOf('day');
  const deadlineHour = moment().hour(10).minute(0);
  let returnMoment = moment().add(1, 'day');
  if (moment().isBefore(deadlineHour) && moment().isSameOrAfter(startOfDay)) {
    returnMoment = moment();
  }
  return asString ? returnMoment.format('DD-MM-YYYY') : returnMoment;
}

export function moveArray(arr, idx, direction) {
  if (direction === 'up') {
    return [
      ...arr.slice(0, idx - 1),
      arr[idx],
      arr[idx - 1],
      ...arr.slice(idx + 1)
    ];
  }
  return [
    ...arr.slice(0, idx),
    arr[idx + 1],
    arr[idx],
    ...arr.slice(idx + 2)
  ];
}

export const pickupOptions = [
  '08:00',
  '08:15',
  '08:30',
  '08:45',
  '09:00',
  '09:15',
  '09:30',
  '09:45',
  '10:00',
  '10:15',
  '10:30',
  '10:45',
  '11:00',
  '11:15',
  '11:30',
  '11:45',
  '12:00',
  '12:15',
  '12:30',
  '12:45',
  '13:00',
  '13:15',
  '13:30',
  '13:45',
  '14:00',
  '14:15',
  '14:30',
  '14:45',
  '15:00',
  '15:15',
  '15:30',
  '15:45',
  '16:00',
  '16:15',
  '16:30',
  '16:45',
  '17:00',
  '17:15',
  '17:30',
  '17:45',
  '18:00',
];

export const airportPickupOptions = [
  '00:00',
  '00:15',
  '00:30',
  '00:45',
  '01:00',
  '01:15',
  '01:30',
  '01:45',
  '02:00',
  '02:15',
  '02:30',
  '02:45',
  '03:00',
  '03:15',
  '03:30',
  '03:45',
  '04:00',
  '04:15',
  '04:30',
  '04:45',
  '05:00',
  '05:15',
  '05:30',
  '05:45',
  '06:00',
  '06:15',
  '06:30',
  '06:45',
  '07:00',
  '07:15',
  '07:30',
  '07:45',
  '08:00',
  '08:15',
  '08:30',
  '08:45',
  '09:00',
  '09:15',
  '09:30',
  '09:45',
  '10:00',
  '10:15',
  '10:30',
  '10:45',
  '11:00',
  '11:15',
  '11:30',
  '11:45',
  '12:00',
  '12:15',
  '12:30',
  '12:45',
  '13:00',
  '13:15',
  '13:30',
  '13:45',
  '14:00',
  '14:15',
  '14:30',
  '14:45',
  '15:00',
  '15:15',
  '15:30',
  '15:45',
  '16:00',
  '16:15',
  '16:30',
  '16:45',
  '17:00',
  '17:15',
  '17:30',
  '17:45',
  '18:00',
  '18:15',
  '18:30',
  '18:45',
  '19:00',
  '19:15',
  '19:30',
  '19:45',
  '20:00',
  '20:15',
  '20:30',
  '20:45',
  '21:00',
  '21:15',
  '21:30',
  '21:45',
  '22:00',
  '22:15',
  '22:30',
  '22:45',
  '23:00',
  '23:15',
  '23:30',
  '23:45'
];

export const basicPickupOptions = [
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
];

export const joinedTransferPickupOptions = [
  '10:00',
  '14:00',
  '18:00'
];

export function formatAMPM(momentDate) {
  return momentDate.format('h:mm A');
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js